import {
  Box,
  Grid,
  Button,
  IconButton,
  InputBase,
} from "@mui/material";
import { useEffect, useState, useMemo } from "react";
import { baseUrl } from "../utils/baseUrl";
import SliderComponent from "../Components/SliderItems";
import { useWindowWidth } from "../Components/Vibes/useWindow";
import Loader from "../Components/loader";
import { ReactComponent as SearchIcon } from "../Assets/search.svg";
import { useGetPartnerZonesQuery } from "../Slices/roomNateApis";
import { useGlobalAuthContext } from "../context/AuthContext";
import { fallBackManualItemZones } from "../utils/fallBackData";
import { getSpatialChipSx } from "../theme/spatial";


const ManuallyItems = ({
  roomActive,
  roomItemsList,
  roomActiveLayout,
  itemsWithSup,
  handleItems,
  setSupZones,
  currentZone,
  loading,
  errorLayoutGlobal,
  allSupplementaryItems,
  loadingAll,
}) => {
  const windowWidth = useWindowWidth();

  const {partner} = useGlobalAuthContext();

  const { data: partnerZones } = useGetPartnerZonesQuery(partner, {
      skip: !partner,
  });
    
  const manualItemsData = (Array.isArray(partnerZones) && partnerZones?.length > 0 
  ? partnerZones 
  : fallBackManualItemZones
  )?.filter(zone => zone.visibleOnManualItem);

  const [showSearch, setShowSearch] = useState(false);
  const [searchText, setSearchText] = useState("");

  const centerFlag = windowWidth >= 950;

  const derivedTab = useMemo(() => {
    if (!currentZone || !manualItemsData) return 0;
    const idx = manualItemsData.findIndex(z => z.value === currentZone);
    return idx >= 0 ? idx : 0;
  }, [currentZone, manualItemsData]);

  const [selectedTab, setSelectedTab] = useState(derivedTab);

  useEffect(() => {
    setSelectedTab(derivedTab);
  }, [derivedTab]);

  const filteredItems = searchText?.trim()
    ? allSupplementaryItems?.filter((item) =>
        item?.name?.toLowerCase().includes(searchText.toLowerCase())
      )
    : itemsWithSup;

  const sortedItems = useMemo(() => {
    if (!filteredItems || !Array.isArray(filteredItems)) return filteredItems;
    return [...filteredItems].sort((a, b) => {
      const pa = Number(a?.likelihood);
      const pb = Number(b?.likelihood);
      const la = Number.isFinite(pa) ? pa : -1;
      const lb = Number.isFinite(pb) ? pb : -1;
      return lb - la;
    });
  }, [filteredItems]);

  return (
    <>
      <Grid item xs={12} sx={{ position: "relative", pt: "4px" }}>
        {loading || (showSearch && loadingAll) ? (
          <Box
            sx={{
              minHeight: "170px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Loader />
          </Box>
        ) : (
          <>
            <Box
              sx={{
                py: 0.5,
                px: 1.5,
                display: "flex",
                justifyContent: centerFlag ? "center" : "flex-start",
                gap: "5px",
                overflowX: "auto",
                scrollbarWidth: "none",
                "&::-webkit-scrollbar": { display: "none" },
                "& .MuiButton-root:hover": {
                  backgroundColor: "#ffffff",
                },
              }}
            >
              <IconButton
                disableRipple
                onClick={() => setShowSearch((prev) => !prev)}
                sx={{
                  border: "1px solid rgba(218, 218, 218, 0.6)",
                  borderRadius: "980px !important",
                  height: "28px",
                  width: "28px",
                  backgroundColor: "rgba(255, 255, 255, 1)",
                  "&:hover": {
                    backgroundColor: "#ffffff",
                  },
                }}
              >
                <SearchIcon style={{ width: 14, height: 14 }} />
              </IconButton>

              <Box
                sx={{
                  visibility: showSearch ? "visible" : "hidden", 
                  opacity: showSearch ? 1 : 0, 
                  transition: "opacity 0.3s ease, visibility 0.3s ease", 
                  minWidth: showSearch ? "200px" : "0px", 
                  width: "0",
                  mr: showSearch ? 1 : 0,
                  backgroundColor: "#ffffff",
                  borderRadius: "980px",
                }}
              >
                <InputBase
                  placeholder="Search..."
                  value={searchText}
                  onChange={(e) => {
                    setSearchText(e.target.value);
                  }}
                  sx={{
                    border: "1px solid #ddd",
                    borderRadius: "980px",
                    px: showSearch ? 1.5 : 0,
                    height: "28px",
                    fontSize: "12px",
                    minWidth: "100%",
                    visibility: showSearch ? "visible" : "hidden",
                    backgroundColor: "#ffffff",
                  }}
                />
              </Box>

              {manualItemsData?.map((option, index) => (
                <Button
                  key={index}
                  onClick={() => {
                    setSelectedTab(index);
                    setSupZones(option?.value);
                    setSearchText("");
                    setShowSearch(false);
                  }}
                  sx={getSpatialChipSx({ selected: index === selectedTab })}
                >
                  {option?.label}
                </Button>
              ))}
            </Box>

            <SliderComponent
              baseUrl={baseUrl}
              handleItems={handleItems}
              errorLayoutGlobal={errorLayoutGlobal}
              itemsWithSup={sortedItems}
              roomActive={roomActive}
              roomActiveLayout={roomActiveLayout}
              roomItemsList={roomItemsList}
            />
          </>
        )}
      </Grid>
    </>
  );
};

export default ManuallyItems;
